{
  "SERVICES_LIST_PAGE": "Valitse palvelu",
  "SERVICES_CONFIRMATION_PAGE": "Tilaa",
  "SERVICES_THANK_YOU_PAGE": "Valmis!"
}